import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from './PdfStyles';

const PdfField = ({ label, value }) => (
  <View style={styles.fieldContainer}>
    <Text style={styles.fieldLabel}>{label}:</Text>
    <Text style={styles.fieldValue}>{value || ' '}</Text>
  </View>
);

export default PdfField;